import CookieUtils from '@/utils/cookies';

const state = {
  // Общее состояние панели
  panelVisible: true,
  activeFilterSet: null, // 'telegram', 'results', etc.
  
  // Фильтры для Telegram
  telegram: {
    filterStatus: "",
    followersFrom: null,
    followersTo: null,
    updatedFrom: "",
    updatedTo: "",
    lastMessageBefore: "",
    createdFrom: "",
    createdTo: "",
    filterLanguage: "",
    filterCountry: "",
    filterSection: "",
    filterChannelName: "",
    filterUsername: "",
    filterChannelId: "",
    filterDescription: "",
    filterType: "",
    filterAccessType: "",
    filterIsMonitoring: "",
    filterTags: [],
    // Telegram networks: one network (id) or only channels in any network
    filterNetwork: null,
    filterInNetwork: false,
    // Sorting
    sortField: '',
    sortDirection: 'asc',
    // Pagination
    currentPage: 1,
    limit: 20,
    totalItems: 0,
    totalPages: 1
  },
  
  // Фильтры для Dzen
  dzen: {
    search: '',
    description: '',
    is_monitoring: null,
    status: null,
    topic_id: null,
    geolocation_id: null,
    subscribers_from: null,
    subscribers_to: null,
    messages_from: null,
    messages_to: null,
    updated_from: null,
    updated_to: null,
    tags: [],
    // Sorting
    sort_by: '',
    sort_order: 'desc',
    // Pagination
    currentPage: 1,
    limit: 50,
    totalItems: 0,
    totalPages: 1
  },

  // Фильтры для Results (будет добавлено позже)
  results: {
    // ...
  }
};

const mutations = {
  SET_PANEL_VISIBLE(state, visible) {
    state.panelVisible = visible;
  },
  
  SET_ACTIVE_FILTER_SET(state, filterSet) {
    state.activeFilterSet = filterSet;
  },
  
  UPDATE_TELEGRAM_FILTER(state, { field, value }) {
    state.telegram[field] = value;
  },
  
  UPDATE_TELEGRAM_FILTERS(state, filters) {
    Object.assign(state.telegram, filters);
  },
  
  RESET_TELEGRAM_FILTERS(state) {
    state.telegram = {
      ...state.telegram,
      filterStatus: "",
      followersFrom: null,
      followersTo: null,
      updatedFrom: "",
      updatedTo: "",
      lastMessageBefore: "",
      createdFrom: "",
      createdTo: "",
      filterLanguage: "",
      filterCountry: "",
      filterSection: "",
      filterChannelName: "",
      filterUsername: "",
      filterChannelId: "",
      filterDescription: "",
      filterType: "",
      filterAccessType: "",
      filterIsMonitoring: "",
      filterTags: [],
      filterNetwork: null,
      filterInNetwork: false,
      currentPage: 1
    };
  },
  
  SET_TELEGRAM_PAGINATION(state, { currentPage, totalPages, totalItems }) {
    if (currentPage !== undefined) state.telegram.currentPage = currentPage;
    if (totalPages !== undefined) state.telegram.totalPages = totalPages;
    if (totalItems !== undefined) state.telegram.totalItems = totalItems;
  },
  
  SET_TELEGRAM_SORTING(state, { sortField, sortDirection }) {
    state.telegram.sortField = sortField;
    state.telegram.sortDirection = sortDirection;
  },
  
  LOAD_TELEGRAM_FILTERS_FROM_CACHE(state) {
    const cookieKey = 'telegram_filters';
    const cached = CookieUtils.get(cookieKey, {});
    if (cached && Object.keys(cached).length > 0) {
      state.telegram = {
        ...state.telegram,
        ...cached,
        currentPage: 1, // Reset page on load
        limit: Math.min(cached.limit || 20, 100) // Cap limit at 100
      };
      state.panelVisible = cached.filtersVisible !== undefined ? cached.filtersVisible : true;
    }
  },
  
  SAVE_TELEGRAM_FILTERS_TO_CACHE(state) {
    const cookieKey = 'telegram_filters';
    const filters = {
      ...state.telegram,
      filtersVisible: state.panelVisible
    };
    CookieUtils.set(cookieKey, filters, 90);
  },

  // Dzen mutations
  UPDATE_DZEN_FILTER(state, { field, value }) {
    state.dzen[field] = value;
  },

  UPDATE_DZEN_FILTERS(state, filters) {
    Object.assign(state.dzen, filters);
  },

  RESET_DZEN_FILTERS(state) {
    state.dzen = {
      ...state.dzen,
      search: '',
      description: '',
      is_monitoring: null,
      status: null,
      topic_id: null,
      subscribers_from: null,
      subscribers_to: null,
      messages_from: null,
      messages_to: null,
      updated_from: null,
      updated_to: null,
      geolocation_id: null,
      tags: [],
      currentPage: 1
    };
  },

  SET_DZEN_PAGINATION(state, { currentPage, totalPages, totalItems }) {
    if (currentPage !== undefined) state.dzen.currentPage = currentPage;
    if (totalPages !== undefined) state.dzen.totalPages = totalPages;
    if (totalItems !== undefined) state.dzen.totalItems = totalItems;
  },

  SET_DZEN_SORTING(state, { sort_by, sort_order }) {
    state.dzen.sort_by = sort_by;
    state.dzen.sort_order = sort_order;
  },

  LOAD_DZEN_FILTERS_FROM_CACHE(state) {
    const cookieKey = 'dzen_filters';
    const cached = CookieUtils.get(cookieKey, {});
    if (cached && Object.keys(cached).length > 0) {
      state.dzen = {
        ...state.dzen,
        ...cached,
        currentPage: 1
      };
      if (state.activeFilterSet === 'dzen') {
        state.panelVisible = cached.filtersVisible !== undefined ? cached.filtersVisible : true;
      }
    }
  },

  SAVE_DZEN_FILTERS_TO_CACHE(state) {
    const cookieKey = 'dzen_filters';
    const filters = {
      ...state.dzen,
      filtersVisible: state.panelVisible
    };
    CookieUtils.set(cookieKey, filters, 90);
  }
};

const actions = {
  togglePanel({ commit, state }) {
    commit('SET_PANEL_VISIBLE', !state.panelVisible);
    commit('SAVE_TELEGRAM_FILTERS_TO_CACHE');
  },
  
  showPanel({ commit }) {
    commit('SET_PANEL_VISIBLE', true);
  },
  
  hidePanel({ commit }) {
    commit('SET_PANEL_VISIBLE', false);
  },
  
  setActiveFilterSet({ commit }, filterSet) {
    commit('SET_ACTIVE_FILTER_SET', filterSet);
  },
  
  updateTelegramFilter({ commit }, payload) {
    commit('UPDATE_TELEGRAM_FILTER', payload);
    commit('SAVE_TELEGRAM_FILTERS_TO_CACHE');
  },
  
  updateTelegramFilters({ commit }, filters) {
    commit('UPDATE_TELEGRAM_FILTERS', filters);
    commit('SAVE_TELEGRAM_FILTERS_TO_CACHE');
  },
  
  resetTelegramFilters({ commit }) {
    commit('RESET_TELEGRAM_FILTERS');
    commit('SAVE_TELEGRAM_FILTERS_TO_CACHE');
  },
  
  setTelegramPagination({ commit }, pagination) {
    commit('SET_TELEGRAM_PAGINATION', pagination);
    commit('SAVE_TELEGRAM_FILTERS_TO_CACHE');
  },
  
  setTelegramSorting({ commit }, sorting) {
    commit('SET_TELEGRAM_SORTING', sorting);
    commit('SAVE_TELEGRAM_FILTERS_TO_CACHE');
  },
  
  loadTelegramFiltersFromCache({ commit }) {
    commit('LOAD_TELEGRAM_FILTERS_FROM_CACHE');
  },
  
  saveTelegramFiltersToCache({ commit }) {
    commit('SAVE_TELEGRAM_FILTERS_TO_CACHE');
  },

  // Dzen actions
  updateDzenFilter({ commit }, payload) {
    commit('UPDATE_DZEN_FILTER', payload);
    commit('SAVE_DZEN_FILTERS_TO_CACHE');
  },

  updateDzenFilters({ commit }, filters) {
    commit('UPDATE_DZEN_FILTERS', filters);
    commit('SAVE_DZEN_FILTERS_TO_CACHE');
  },

  resetDzenFilters({ commit }) {
    commit('RESET_DZEN_FILTERS');
    commit('SAVE_DZEN_FILTERS_TO_CACHE');
  },

  setDzenPagination({ commit }, pagination) {
    commit('SET_DZEN_PAGINATION', pagination);
    commit('SAVE_DZEN_FILTERS_TO_CACHE');
  },

  setDzenSorting({ commit }, sorting) {
    commit('SET_DZEN_SORTING', sorting);
    commit('SAVE_DZEN_FILTERS_TO_CACHE');
  },

  loadDzenFiltersFromCache({ commit }) {
    commit('LOAD_DZEN_FILTERS_FROM_CACHE');
  },

  saveDzenFiltersToCache({ commit }) {
    commit('SAVE_DZEN_FILTERS_TO_CACHE');
  },

  toggleDzenPanel({ commit, state }) {
    commit('SET_PANEL_VISIBLE', !state.panelVisible);
    commit('SAVE_DZEN_FILTERS_TO_CACHE');
  }
};

const getters = {
  isPanelVisible: state => state.panelVisible,
  activeFilterSet: state => state.activeFilterSet,
  telegramFilters: state => state.telegram,
  resultsFilters: state => state.results,
  
  // Computed values for telegram
  telegramHasActiveFilters: state => {
    const f = state.telegram;
    return !!(f.filterStatus || f.followersFrom || f.followersTo ||
              f.updatedFrom || f.updatedTo || f.lastMessageBefore || f.createdFrom || f.createdTo ||
              f.filterLanguage || f.filterCountry ||
              f.filterSection || f.filterChannelName || f.filterUsername ||
              f.filterChannelId || f.filterDescription || f.filterType ||
              f.filterAccessType || f.filterIsMonitoring ||
              f.filterNetwork || f.filterInNetwork ||
              (f.filterTags && f.filterTags.length > 0));
  },

  dzenFilters: state => state.dzen,

  dzenHasActiveFilters: state => {
    const f = state.dzen;
    return !!(f.search || f.description || f.status || f.topic_id ||
              f.subscribers_from || f.subscribers_to ||
              f.messages_from || f.messages_to ||
              f.updated_from || f.updated_to ||
              f.is_monitoring !== null ||
              (f.tags && f.tags.length > 0));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};